import { changeCustomerFulfillmentMethodStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerFulfillmentMethodSelector";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tSurya/theme/design";
import { css } from "styled-components";

changeCustomerFulfillmentMethodStyles.fulfillmentMethodRadio = {
    css: css`
        color: ${getColor("text.main")};
    `,
};
changeCustomerFulfillmentMethodStyles.fulfillmentMethodRadioGroup = {
    css: css`
        color: ${getColor("text.main")};
    `,
};
changeCustomerFulfillmentMethodStyles.pickUpLocation = {
    wrapper: {
        css: css`
            margin-top: 20px;
            color: ${getColor("text.main")};
        `,
    },
    changeLink: {
        css: css`
            margin-left: 15px;
            /* Not needed  */
            display: none;
            span[class^="TypographyStyle"] {
                color: ${getColor("text.link")};
                &:hover {
                    text-align: center;
                    text-decoration-line: underline;
                }
            }
        `,
    },
};
